import React from "react";
import InfoIcon from "@mui/icons-material/Info";

const Tooltip = ({ text }) => {
  return (
    <Tooltipcomponent message={text}>
      <button
        type="button"
        className="inline-flex items-center rounded-lg border border-gray-500 p-2
        text-sm font-medium text-zinc-800 hover:bg-gray-100
        focus:outline-none focus:ring-2 focus:ring-gray-300"
      >
        <InfoIcon />
      </button>
    </Tooltipcomponent>
  );
};

export default Tooltip;

const Tooltipcomponent = ({ message, children }) => {
  return (
    <div className="group relative inline-flex items-center">
      {children}

      <div
        className="absolute bottom-full left-8 w-[300px] z-10 mb-2
    -translate-x-1/2 scale-0 transform
    rounded-lg bg-gray-800 px-3 py-2 text-xs text-white
    transition-all duration-200 group-hover:scale-100"
      >
        {message}

        <div
          className="absolute -bottom-1 left-1/2 h-2 w-2
      -translate-x-1/2 rotate-45 bg-gray-800"
        />
      </div>
    </div>
  );
};
